import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import Mining from './pages/Mining';
import CoinMinting from './pages/CoinMinting';
import MetalProcessing from './pages/MetalProcessing';
import Distribution from './pages/Distribution';
import MarketData from './pages/MarketData';
import Resources from './pages/Resources';
import Contact from './pages/Contact';

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mining" element={<Mining />} />
          <Route path="/coin-minting" element={<CoinMinting />} />
          <Route path="/metal-processing" element={<MetalProcessing />} />
          <Route path="/distribution" element={<Distribution />} />
          <Route path="/market-data" element={<MarketData />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}

export default App;